import { isQuiet, lastTouch, type Card } from '@hmawiw/shared';
import { boardCards } from '../store/cards';
import { isLate } from './dates';

export const STALE_AFTER_MS = 14 * 24 * 3_600_000;

export interface Review {
  /** Past their due time, most overdue first. */
  overdue: Card[];
  /** Must, yet dreaded or meh: the cards the board exists for, oldest first. */
  stuck: Card[];
  /** Ongoing cards past their rhythm, the longest silence first. */
  quiet: Card[];
  /** Open and untouched for two weeks, oldest change first. */
  stale: Card[];
}

/** The weekly look: each open card lands in the first section it matches, so nothing is listed twice. */
export function reviewOf(cards: Record<string, Card>, now: number): Review {
  const open = boardCards(cards, now);
  const overdue = open.filter((c) => c.dueAt !== null && isLate(c.dueAt, now)).sort((a, b) => (a.dueAt ?? 0) - (b.dueAt ?? 0));
  const taken = new Set(overdue.map((c) => c.id));
  const stuck = open.filter((c) => !taken.has(c.id) && c.band === 0 && c.motivation === 0).sort((a, b) => a.createdAt - b.createdAt);
  for (const c of stuck) taken.add(c.id);
  const quiet = open.filter((c) => !taken.has(c.id) && isQuiet(c, now)).sort((a, b) => lastTouch(a) - lastTouch(b));
  for (const c of quiet) taken.add(c.id);
  const stale = open.filter((c) => !taken.has(c.id) && c.repeat?.kind !== 'ongoing' && now - c.updatedAt > STALE_AFTER_MS).sort((a, b) => a.updatedAt - b.updatedAt);
  return { overdue, stuck, quiet, stale };
}
